<template>
  <div class="contents">
    <div class="layout">
      <div class="page-top">
        <h2>협업 신청 상세</h2>
        <div class="breadcrumbs">
          <span>협업 신청 관리</span>
          <span class="color-black">협업 신청 상세</span>
        </div>
      </div>
      <div class="white-panel mt30">
        <div class="table-wrap">
          <table class="table-type2">
            <colgroup>
              <col style="width:150px;">
              <col>
            </colgroup>
            <tbody>
              <tr>
                <th>작성자</th>
                <td>
                  <span>{{ collaboration.userAccountId }}</span>
                </td>
              </tr>
              <tr>
                <th>신청자명</th>
                <td>
                  <span>{{ collaboration.name }}</span>
                </td>
              </tr>
              <tr>
                <th>연락처</th>
                <td>
                  <span>{{ collaboration.phoneNum }}</span>
                </td>
              </tr>
              <tr>
                <th>이메일</th>
                <td>
                  <span>{{ collaboration.email }}</span>
                </td>
              </tr>
              <tr>
                <th>기업명</th>
                <td>
                  <span>{{ collaboration.companyName }}</span>
                </td>
              </tr>
              <tr>
                <th>관심작가</th>
                <td>
                  <span>{{ collaboration.interestArtist }}</span>
                </td>
              </tr>
              <tr>
                <th>선호 연락 시간</th>
                <td>
                  <span>{{ preferredContactTimeLabel }}</span>
                </td>
              </tr>
              <tr>
                <th>등록일</th>
                <td>
                  <span>{{ collaboration.createdAt }}</span>
                </td>
              </tr>
              <tr>
                <th>내용</th>
                <td>
                  <span>{{ collaboration.content }}</span>
                </td>
              </tr>
              <tr><td colspan="2"><hr/></td></tr>
              <tr>
                <th>답변자</th>
                <td>
                  <span>{{ collaboration.answerAdminAccountId }}</span>
                </td>
              </tr>
              <tr>
                <th>답변일</th>
                <td>
                  <span>{{ collaboration.answeredAt }}</span>
                </td>
              </tr>
              <tr>
                <th>답변</th>
                <td>
                  <textarea id="answer" v-model="collaboration.answer" placeholder="" />
                </td>
              </tr>
            </tbody>
          </table>
        </div>
      </div>
      <div class="button-panel mt30">
        <div class="left">
          <router-link to="/support/collaboration" class="button white-button round-button gray2">목록</router-link>
        </div>
        <div class="right">
          <button v-if="collaborationUuid" @click="updateItem" type="button" class="button navy-button">답변하기</button>
        </div>
      </div>
    </div>
  </div>
</template>

<script setup>
import { computed, onMounted, ref } from 'vue';
import { apiClient } from '@/services/auth-header';
import { useRoute } from 'vue-router';
import router from '@/router';
import { PREFERRED_CONTACT_TIME } from '@/common/common-enum';

const route = useRoute();
const collaboration = ref({
  userAccountId: '',
  name: '',
  phoneNum: '',
  email: '',
  companyName: '',
  interestArtist: '',
  preferredContactTime: '',
  createdAt: '',
  content: '',
  isAnswered: '',
  answerAdminAccountId: '',
  answeredAt: '',
  answer: '',
});

const collaborationUuid = ref(route.params.uuid);

const API_URL = '/support'

const preferredContactTimeLabel = computed(() => {
  return getLabelFromType(PREFERRED_CONTACT_TIME, collaboration.value.preferredContactTime) || '';
});

const loadItem = async () => {
  try {
    const response = await apiClient.get(`${API_URL}/collaborations/${collaborationUuid.value}`);
    collaboration.value = response.data;
  } catch (error) {
    console.error('Error fetching collaborationDetail data:', error);
  }
};

const getLabelFromType = (typeList, value) => {
  const label = typeList.find(type => type.value === value)?.label;
  return label;
}

const updateItem = async () => {
  try {
    await apiClient.put(`${API_URL}/collaborations/${collaborationUuid.value}`, { answer: collaboration.value.answer });
    alert('답변 성공');
    router.replace('/support/collaboration');
  } catch (error) {
    console.error('Error saving collaboration:', error);
  }
};

onMounted(() => {
  if (collaborationUuid.value) {
    loadItem();
  }
});
</script>
